/**
 * LayoutSplitter  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { LayoutState_Splitter } from "./LayoutState";
import { useResizeHandle } from "../Resize/useResizeHandle";

export interface ILayoutSplitter {
	state: LayoutState_Splitter;
}

export const LayoutSplitter: React.FC<ILayoutSplitter> = ({ state }) => {
	const [ splitterProps, { active, disabled } ] = useResizeHandle(state.id);
	const baseClass = BEM("edt-layout", "splitter", {
		active,
		disabled
	});

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("splitter-handle").toClassName()} {...splitterProps} />
		</div>
	);
};

LayoutSplitter.displayName = "LayoutSplitter";
